export default __webpack_public_path__ + "static/media/eIcon1.4daa6b27.svg";